import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import i18n from "i18next";
import Cookies from "js-cookie";
import MobileMenu from "./MobileMenu";
import logo from '../img/logow.png'

import { LinkContext } from "../LinkProvider";
import { useContext } from "react";

function Header() {
    const { t } = useTranslation();
    const location = useLocation();

    const { link } = useContext(LinkContext);

    const languages = [
        { value: 'en', label: 'EN' },
        { value: 'ru', label: 'RU' },
        { value: 'it', label: 'IT' },
        { value: 'pl', label: 'PL' },
        { value: 'de', label: 'DE' },
        { value: 'cz', label: 'CZ' },
        { value: 'es', label: 'ES' },
    ]

    const storedLang = Cookies.get("i18next");
    const [currentLang, setCurrentLang] = useState(storedLang || 'en');

    useEffect(() => {
        if (storedLang && storedLang !== currentLang) {
            setCurrentLang(storedLang);
            i18n.changeLanguage(storedLang);
        }
        // eslint-disable-next-line
        document.body.setAttribute('dir', storedLang === 'ar' ? 'rtl' : 'ltr');
    }, [storedLang]);
    

    const handleChangeLang = (selectedLang) => {
        setCurrentLang(selectedLang.value);
        i18n.changeLanguage(selectedLang.value);
        Cookies.set("i18next", selectedLang.value);
    };

    return (
        <div className="bg-black">
            <div className="hidden max-w-[1280px] h-[60px] justify-between mx-auto xl:flex items-center">
                <Link to="/">
                    <img src={logo} alt="" className="w-[80px]"/>
                </Link>
                <Link to="/tradingproducts"><p className={`text-[16px] font-light roboto ${location.pathname === '/tradingproducts' ? 'text-[#B30101]' : 'text-[#FFFFFFB2]'}`}>{t('header.1')}</p></Link>
                <Link to="/tradingtools"><p className={`text-[16px] font-light roboto ${location.pathname === '/tradingtools' ? 'text-[#B30101]' : 'text-[#FFFFFFB2]'}`}>{t('header.2')}</p></Link>
                <Link to="/accounts"><p className={`text-[16px] font-light roboto ${location.pathname === '/accounts' ? 'text-[#B30101]' : 'text-[#FFFFFFB2]'}`}>{t('header.3')}</p></Link>
                <Link to="/aboutus"><p className={`text-[16px] font-light roboto ${location.pathname === '/aboutus' ? 'text-[#B30101]' : 'text-[#FFFFFFB2]'}`}>{t('header.4')}</p></Link>
                <Dropdown
                    options={languages}
                    placeholder="EN"
                    onChange={handleChangeLang}
                    value={languages.find(lang => lang.value === currentLang)}
                />
                <a href={`${link}`}>
                    <div className="button cursor-pointer">
                        <p className="inter text-white text-[16px]">{t('header.button')}</p>
                    </div>
                </a>
            </div>
            <div className="xl:hidden flex mx-[20px] items-center justify-between h-[60px]">
                <Link to="/">
                    <img src={logo} alt="" className="w-[60px]"/>
                </Link>
                <Dropdown
                    options={languages}
                    placeholder="EN"
                    onChange={handleChangeLang}
                    value={languages.find(lang => lang.value === currentLang)}
                    className="ml-auto mr-[20px]"
                />
                <MobileMenu/>
            </div>
        </div>
    );
}

export default Header;
